
    /* ===================== */
    /* ======= REELS ======= */
    /* ===================== */

export const DESCUBRE = [
	{
		index: "1",
		songName: "Cancion1",
		songimg: "./image/listas/urbano/05.jpg",
		songCut: "https://dl.dropbox.com/scl/fi/wcbs9rvmc0gpoz6v441e1/Mora-MODELITO.mp3?rlkey=i7novdxoyqzrct3y85jevrdzf&dl=1",		
	    author: '4b',
	    authorLink: 'alibhtty',
	},
	{
		index: "2",
		songName: "Cancion2",
		songimg: "./image/listas/urbano/06.jpg",
		songCut: "https://dl.dropbox.com/scl/fi/s5rfue5ahl6nvjklqw7gj/KAROL-G-CONTIGO.mp3?rlkey=jy27go1nk2dgjvsa5o75gdzuu&dl=1",
	    author: 'alibhtty',
	    authorLink: '#',
	},
	{
		index: "3",
		songName: "Cancion3",
		songimg: "./image/listas/urbano/07.jpg",
		songCut: "https://dl.dropbox.com/scl/fi/qvrf3s5w5qum3t5rf43oe/Lola-Indigo-1000COSAS.mp3?rlkey=xd7is7vjkq2ex03vrkr2t29p6&dl=1",
	    author: 'cy-user',
	    authorLink: '#',
	},
	{
		index: "4",
		songName: "Cancion4",
		songimg: "./image/listas/urbano/08.jpg",
		songCut: "https://dl.dropbox.com/scl/fi/vrh4tztmaeoiq42amdhmc/Sky-CRUSH.mp3?rlkey=rfi819x3wpmnfvyye25ls0kh6&dl=1",
	    author: 'boomcar',
	    authorLink: '#',
	}
  ];